<template>
    <div>
        <!-- 主体 -->
        <div v-show="!addDialogVisible && !editDialogVisible">
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">签约项目管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">
                        <el-col :span="6">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:70%"
                                collapse-tags :props="props"></el-cascader>
                        </el-col>
                        <el-col :span="4">
                            <span>城市 </span>
                            <el-select v-model="condition.city" style="margin-left:10px;width:70%" placeholder="全部"
                                clearable>
                                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
                                    :value="item.city">
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :span="4">
                            <span>甲方名头 </span>
                            <el-input v-model="condition.party_title" placeholder="请输入甲方名头"
                                style="margin-left:10px;width: 60%;"></el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>合同名称 </span>
                            <el-input v-model="condition.contract_name" placeholder="请输入合同名称"
                                style="margin-left:10px;width: 60%;"></el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>项目名称 </span>
                            <el-input v-model="condition.project_name" placeholder="请输入项目名称"
                                style="margin-left:10px;width: 60%;"></el-input>
                        </el-col>
                    </el-row>

                    <el-row style="padding-left: 46px; padding-top: 10px; text-align: right;margin-right: 50px;">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Del(null)">
                            删除</el-button>
                        <el-button style="width: 85px; border: 1px solid #006E4B; color: #006E4B;" @click="AddForm">
                            新增</el-button>
                        <div style="display:inline-block;margin-left:220px">
                            <download-excel class="export-excel-wrapper" :fields="download_excel" title="签约项目清单"
                                        name="签约项目清单.xls" :fetch="ExportForm"
                                        style="margin-left:-180px;top:100px">
                                <el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    导表</el-button>
                            </download-excel>
                        </div>
                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="540"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="50">
                                </el-table-column>
                                <el-table-column align="center" label="序号" width="50">
                                    <template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
                                </el-table-column>
                                <el-table-column align="center" label="组织架构" width="300">
                                    <template slot-scope="scope">
                                        {{ $globals.group_name + "/" + scope.row.organize_name }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="city" align="center" label="城市" width="80">
                                </el-table-column>
                                <el-table-column prop="contract_code" align="center" label="合同编码" width="100">
                                </el-table-column>
                                <el-table-column prop="party_title" align="center" label="甲方名头" width="100">
                                </el-table-column>
                                <el-table-column prop="contract_name" align="center" label="合同名称" width="120">
                                </el-table-column>
                                <el-table-column prop="contract_start_date" align="center" label="合同开始时间" width="120">
                                </el-table-column>
                                <el-table-column prop="contract_end_date" align="center" label="合同终止时间" width="120">
                                </el-table-column>
                                <el-table-column prop="contract_unit_title" align="center" label="合同核算单位" width="110">
                                </el-table-column>
                                <el-table-column prop="service_charge_standard_title" align="center" label="服务费核算标准"
                                    width="120">
                                </el-table-column>
                                <el-table-column prop="project_name" align="center" label="项目名称" width="100">
                                </el-table-column>
                                <el-table-column prop="project_site" align="center" label="项目地址" width="100">
                                </el-table-column>
                                <el-table-column align="center" label="操作" fixed="right" width="150">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/详情.png" @click="Details(scope.row.id)" />
                                        <img src="../../../assets/编辑.png" @click="EditForm(scope.row)" />
                                        <img src="../../../assets/删除.png" @click="Del(scope.row.id)" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <!-- <add ref="add" v-show="addDialogVisible"></add>

        <edit ref="edit" v-show="editDialogVisible"></edit> -->

        <add ref="add" v-show="addDialogVisible" :ruleForm="form" :organizeList="organizeList" @return="Return"></add>
        <edit ref="edit" v-show="editDialogVisible" :ruleForm="form" @return="Return"></edit>


    </div>
</template>

<script>
import add from "./QyxmGl_add.vue";
import edit from "./QyxmGl_edit.vue";
export default {
    components: {
        add: add,
        edit: edit,
    },
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],

            //条件
            condition: {
                city: "",
                party_title: "",
                contract_name: "",
                project_name: "",
                organize_ids: []
            },

            //详情
            form: {
                id: "",
                company_id: "",
                company_name: "",
                organize_id: "",
                organize_ids: '',
                organize_temporary_ids: [],
                organize_name: '',
                project_id: '',
                modular_name: "",
                city: "",
                contract_code: "",
                contract_unit_title: "",
                service_charge_standard_title: "",
                partner_name: "",
                spare6: "",
                party_title: "",
                contract_name: "",
                contract_start_date: "",
                contract_end_date: "",
                contract_unit: "",
                service_charge_standard: "",
                project_name: "",
                project_site: "",
                contract_headcount: "",
                contract_min_count: "",
                contract_max_labor_hour: "",
                contract_min_day_labor_hour: "",
                contract_min_month_labor_hour: "",
                is_client_require: "0",
                is_client_require_title: "",
                monthly_contract_amount: "",
                agency_company: "",
                clock_in_reference_location: "",
                projectPostList: [],
                shiftList: [],
                shiftCount: [1],
                contractList: [],
                contractCount: [1],
                withdrawal_date: '',
                mobilization_date: '',
                settlement_method: '',
                budget_quota_number: '',
                annual_contract_revenue: '',
                material_quota: '',
                series_id: '',
                andInnovation_id: '',
            },

            download_excel: {
                "组织架构": "organize_name",
                "城市":"city",
                "甲方名头": "party_title",
                "合同名称":"contract_name",
                "合同开始时间": "contract_start_date",
                "合同终止时间": "contract_end_date",
                "合同核算单位": "contract_unit_title",
                "项目名称": "project_name",
                "项目地址": "project_site",
            },

            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },

            //页面相关
            addDialogVisible: false,
            editDialogVisible: false,

            //组织架构数据
            organizeList: [],

            // //分公司数据
            // companyList: [],
            // //板块数据
            // plateList: [],
            //甲方名头数据
            partnerList: [],

            //复选框ids
            ids: [],
        };
    },
    methods: {
        //返回
        Return(e) {
            if (e == 'add') {
                this.addDialogVisible = false;
            } else {
                this.editDialogVisible = false;
            }
            this.trash();
            this.Find();
        },
        //列表点击复选框
        handleSelectionChange(e) {
            this.ids = [];
            e.forEach(item => {
                this.ids.push(item.id);
            })
        },
        //查询
        async Find() {
            var temporary = [];
            this.condition.organize_ids.forEach(item => {
                temporary.push(item[item.length - 1]);
            })
            var organize_ids = "";
            temporary.forEach(item => {
                organize_ids += item + ",";
            })
            var url = 'project/find';
            var record = {
                page_num: this.page_num,
                page_size: this.page_size,
                organize_ids: organize_ids,
                city: this.condition.city,
                party_title: this.condition.party_title,
                contract_name: this.condition.contract_name,
                project_name: this.condition.project_name,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning('请求失败！请稍后重试');
                }
            }
        },


        //导表
        async ExportForm() {
            var temporary = [];
            this.condition.organize_ids.forEach(item => {
                temporary.push(item[item.length - 1]);
            })
            var organize_ids = "";
            temporary.forEach(item => {
                organize_ids += item + ",";
            })
            var url = 'project/selectAlls';
            var record = {
                organize_ids: organize_ids,
                city: this.condition.city,
                party_title: this.condition.party_title,
                contract_name: this.condition.contract_name,
                project_name: this.condition.project_name,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    if(data.length > 0){
                        this.$message.success("导表成功！文件下载中！");
                        return data;
                    }else{
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                    
                } else {
                    this.$message.warning(data);
                }
            }
        },

        //分页
        handleCurrentChange(e) {
            this.page_num = e;
            this.Find();
        },
        //新增页面
        AddForm() {
            this.addDialogVisible = true;
            this.trash();
        },
        //编辑页面
        async EditForm(e) {
            var url = 'project/selectByPrimaryKey';
            var record = {
                id: e.id
            };
            console.log(record)
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.form.id = e.id;

                    this.form.organize_ids = e.organize_ids;
                    var arr = e.organize_ids.split(',');
                    arr.forEach((item, index) => {
                        if (arr[index] == null || arr[index] == '' || arr[index] == NaN) {
                            arr.splice(index, 1);
                        }
                        arr[index] = parseInt(arr[index])
                    })
                    this.form.organize_temporary_ids = arr;
                    this.$refs["add"].Plate(e.company_id);
                    this.form.organize_name = e.organize_name;
                    this.form.organize_id = e.organize_id;
                    this.form.organize_ids = e.organize_ids;
                    this.form.city = e.city;
                    this.form.contract_code = e.contract_code;
                    this.form.spare6 = parseInt(e.spare6);
                    this.form.party_title = e.party_title;
                    this.form.contract_name = e.contract_name;
                    this.form.contract_start_date = e.contract_start_date;
                    this.form.contract_end_date = e.contract_end_date;
                    this.form.contract_unit = e.contract_unit;
                    this.form.service_charge_standard = e.service_charge_standard;
                    this.form.project_name = e.project_name;
                    this.form.project_site = e.project_site;
                    this.form.contract_headcount = e.contract_headcount;
                    this.form.contract_min_count = e.contract_min_count;
                    this.form.contract_max_labor_hour = e.contract_max_labor_hour;
                    this.form.contract_min_day_labor_hour = e.contract_min_day_labor_hour;
                    this.form.contract_min_month_labor_hour = e.contract_min_month_labor_hour;
                    this.form.is_client_require = e.is_client_require;
                    this.form.monthly_contract_amount = e.monthly_contract_amount;
                    this.form.agency_company = e.agency_company;
                    this.form.clock_in_reference_location = e.clock_in_reference_location;
                    this.form.withdrawal_date = data.withdrawal_date;
                    this.form.mobilization_date = data.mobilization_date;
                    this.form.settlement_method = data.settlement_method;
                    this.form.budget_quota_number = data.budget_quota_number;
                    this.form.annual_contract_revenue = data.annual_contract_revenue;
                    this.form.material_quota = data.material_quota;
                    this.form.series_id = data.series_id;
                    this.form.andInnovation_id = data.andInnovation_id;
                    if (data.projectContractList != "" && data.projectContractList != null && data.projectContractList.length > 0) {
                        this.form.contractList = data.projectContractList;
                        this.form.contractCount.length = data.projectContractList.length;
                    } else {
                        this.form.contractList = [{
                            contract_price: ""
                        }];
                        this.form.contracCount = [1];
                    }

                    // this.form.contractList = [{
                    //     contract_price: "1"
                    // }, {
                    //     contract_price: "2"
                    // }, {
                    //     contract_price: "3"
                    // }];
                    // this.form.contractCount.length = 3;
                    this.addDialogVisible = true;
                } else {
                    this.$message.warning('请求失败！请稍后重试');
                }
            }
        },
        //详情页面
        async Details(e) {
            var url = 'project/selectByPrimaryKey';
            var record = {
                id: e
            };
            console.log(record)
            var data = await this.$globals.AxiosPost(url, record);
            if (data === '-2000') {
                this.$message.error('服务器未响应！请稍后重试');
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.form.id = data.id;
                    this.form.organize_name = data.organize_name;
                    this.form.organize_id = data.organize_id;
                    this.form.modular_name = data.modular_name;
                    this.form.city = data.city;
                    this.form.contract_code = data.contract_code;
                    this.form.contract_unit_title = data.contract_unit_title;
                    this.form.service_charge_standard_title = data.service_charge_standard_title;
                    this.form.spare6 = data.spare6;
                    this.form.partner_name = data.partner_name;
                    this.form.party_title = data.party_title;
                    this.form.contract_name = data.contract_name;
                    this.form.contract_start_date = data.contract_start_date;
                    this.form.contract_end_date = data.contract_end_date;
                    this.form.contract_unit = data.contract_unit;
                    this.form.service_charge_standard = data.service_charge_standard;
                    this.form.project_name = data.project_name;
                    this.form.project_site = data.project_site;
                    this.form.contract_headcount = data.contract_headcount;
                    this.form.contract_min_count = data.contract_min_count;
                    this.form.contract_max_labor_hour = data.contract_max_labor_hour;
                    this.form.contract_min_day_labor_hour = data.contract_min_day_labor_hour;
                    this.form.contract_min_month_labor_hour = data.contract_min_month_labor_hour;
                    this.form.is_client_require = data.is_client_require;
                    this.form.projectPostList = data.projectPostList;
                    this.form.is_client_require_title = data.is_client_require_title;
                    this.form.andInnovation_id = data.andInnovation_id;
                    this.form.series_id = data.series_id;
                    if (data.shiftList.length > 0) {
                        this.form.shiftList = data.shiftList;
                        this.form.shiftCount.length = data.shiftList.length;
                    } else {
                        this.form.shiftList = [{
                            id: "",
                            shift: "班次1",
                            start_time: "",
                            end_time: "",
                            person_count: "",
                            spare1: ""
                        }];
                        this.form.shiftCount = [1];
                    }
                    // if (data.shiftList.length > 0) {
                    //     this.form.shiftCount = [];
                    //     this.form.shiftList = [];
                    //     data.shiftList.forEach(item => {
                    //         this.shiftCount.push(1);
                    //         this.shiftList.push({
                    //             id:item.id,
                    //             shift: item.shift,
                    //             start_time: item.start_time,
                    //             end_time: item.end_time,
                    //             person_count: item.person_count,
                    //             spare1: item.person_count,
                    //         });
                    //     })
                    // }
                    this.editDialogVisible = true;
                    this.$refs["edit"].initialize();
                } else {
                    this.$message.warning('请求失败！请稍后重试');
                }
            }
        },
        //删除
        async Del(e) {
            var ids;
            if (e === null || e === "" || e === undefined) {
                if (this.ids === null || this.ids.length <= 0) {
                    this.$message.warning("请先选择操作数据！");
                    return false;
                }
                ids = this.ids;
            } else {
                ids = [e];
            }

            var url = "project/del";
            var record = {
                ids: ids,
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.$message.success(data);
                    this.trash();
                    this.Find();
                } else {
                    this.$message.warning(data);
                }
            }
        },
        //清除数据
        trash() {
            this.form.id = "";
            this.form.company_id = "";
            this.form.organize_id = "";
            this.form.organize_temporary_ids = "";
            this.form.organize_ids = "";
            this.form.city = "";
            this.form.contract_code = "";
            this.form.spare6 = "";
            this.form.party_title = "";
            this.form.contract_name = "";
            this.form.contract_start_date = "";
            this.form.contract_end_date = "";
            this.form.contract_unit = "";
            this.form.service_charge_standard = "";
            this.form.project_name = "";
            this.form.project_site = "";
            this.form.contract_headcount = "";
            this.form.contract_min_count = "";
            this.form.contract_max_labor_hour = "";
            this.form.contract_min_day_labor_hour = "";
            this.form.contract_min_month_labor_hour = "";
            this.form.is_client_require = "0";
            this.form.contractCount = [1];
            this.form.contractList = [{}];
            this.form.withdrawal_date = "";
            this.form.mobilization_date = "";
            this.form.settlement_method = "";
            this.form.budget_quota_number = "";
            this.form.annual_contract_revenue = "";
            this.form.material_quota = "";
            this.form.monthly_contract_amount = "";
            this.form.agency_company = "";
            this.form.series_id = "";
            this.form.andInnovation_id = "";
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
                id: this.condition.project_id
            });
            this.organizeList = this.getTreeData(organizeList.data);
        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        }
    },
    async created() {
        this.Find();
        this.organizeFind();
        // // 分公司
        // var companyList = await this.$globals.AxiosPost("organize/selectOrganizes", {});
        // this.companyList = companyList.data;
        // // 版块
        // var plateList = await this.$globals.AxiosPost("organize/selectOrganizesing", {});
        // this.plateList = plateList.data;
        // 甲方名头
        var partnerList = await this.$globals.AxiosPost("partner/selectFind", {});
        this.partnerList = partnerList.data;
    }
}
</script>

<style scoped="scoped">
>>>.el-button:hover {
    background-color: #FFFFFF;
}

>>>.el-button:focus {
    background-color: #FFFFFF;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #006E4B;
}

>>>.el-input__inner:focus {
    border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
    border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006E4B;
    border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
    border-color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// QyxmGl.vue?61e8fa8a